import { select } from 'd3';
import { closeIcon } from './icons';
import type { HierarchyPointNode, Selection } from 'd3';
import type { TreeNode, TooltipCoordinates } from '../types';

let restoreFocus: HTMLElement | undefined;

// function to remove tooltip
export function removeTooltip(tooltipDiv: Selection<HTMLDivElement, TreeNode, HTMLElement, {}>) {
    tooltipDiv.attr('tabindex', '-1').style('opacity', 1e-6).style('display', 'none');
    restoreFocus?.focus();
    restoreFocus = undefined;
}

// function to create the elements used in the tooltip depending on given data
export const tooltipElements = function (d: HierarchyPointNode<any>) {
    const closeButton = '<div id="tooltip_close-button">' + closeIcon + '</div>',
        name = '<div class="tip_prop">' + d.data.name + ' </div>',
        description = '<div class="tip_desc">' + d.data.description + '</div>',
        type = '<div class="tip_type">' + d.data.type + '</div>',
        enums = '<div class="tip_enums">' + d.data.type.replaceAll('|', ' | ') + '</div>',
        controlType = '<div class="tip_control">' + d.data.control + '</div>';
    let elements = closeButton;
    elements += name;
    // checks which data exist
    if (d.data.description) {
        elements += description;
    }
    if (d.data.type) {
        elements += '<div class="tip_type-container">';
        if (d.data.type.includes('|')) {
            elements += enums;
        } else {
            elements += type;
        }
    }
    if (d.data.artifact) {
        elements += '<div class="tip_type">' + d.data.artifact + '</div>';
    }
    if (d.data.control) {
        elements += controlType;
    }
    if (d.data.type) {
        elements += '</div>';
    }
    return elements;
};

// function to display tooltip depending on data
export function showTooltip(
    coordinates: TooltipCoordinates,
    d: HierarchyPointNode<TreeNode>,
    tooltipDiv: Selection<HTMLDivElement, TreeNode, HTMLElement, {}>
) {
    restoreFocus = document.activeElement as HTMLElement;
    const outerSVG = select('svg#tree-container').node() as HTMLElement;
    // get dimensions of svg container to position tooltip
    const outWidth = outerSVG.getBoundingClientRect().width - 420;
    const outHeight = outerSVG.getBoundingClientRect().height - 300;
    if (coordinates.x > outWidth && coordinates.y > outHeight) {
        tooltipDiv
            .style('top', coordinates.y - 20 + 'px')
            .style('left', coordinates.x - 20 + 'px')
            .style('transform', 'translate(-100%, -100%)');
    } else if (coordinates.x > outWidth && coordinates.y <= outHeight) {
        tooltipDiv
            .style('top', coordinates.y + 20 + 'px')
            .style('left', coordinates.x - 20 + 'px')
            .style('transform', 'translate(-100%, 0)');
    } else if (coordinates.x <= outWidth && coordinates.y > outHeight) {
        tooltipDiv
            .style('top', coordinates.y - 20 + 'px')
            .style('left', coordinates.x + 20 + 'px')
            .style('transform', 'translate(0, -100%)');
    } else {
        tooltipDiv
            .style('top', coordinates.y + 20 + 'px')
            .style('left', coordinates.x + 20 + 'px')
            .style('transform', 'translate(0, 0)');
    }
    if (d.data.description || d.data.type) {
        tooltipDiv.html(tooltipElements(d));
        tooltipDiv.style('opacity', 1).style('display', 'flex').attr('tabindex', '0').node().focus();
        select('#tooltip_close-button').on('click', function () {
            removeTooltip(tooltipDiv);
        });
    } else if (!d.data.type) {
        removeTooltip(tooltipDiv);
    }
}

export function getTooltipCoordinates(event: KeyboardEvent): TooltipCoordinates {
    if (event.target instanceof Element) {
        const targetRect = event.target.getBoundingClientRect();
        return {
            x: targetRect.x,
            y: targetRect.y
        };
    }
}
